// src/utils/countryCurrency.js

// Base currency for user wallet country (registration country)
export const BASE_CURRENCY_BY_COUNTRY = {
    // Send-from countries
    US: 'USD',
    UK: 'GBP',
    CA: 'CAD',
    AU: 'AUD',
    FR: 'EUR',

    // Receive countries (MojoPayr initial rollout)
    SL: 'SLE',
    LR: 'USD', // Liberia receives USD (keep if this is your business rule)
    GN: 'GNF',
    GM: 'GMD',
}

export const getBaseCurrency = (countryCode) => {
    if (!countryCode) return 'USD'
    return BASE_CURRENCY_BY_COUNTRY[String(countryCode).toUpperCase()] || 'USD'
}

// Dropdown options for "Send from"
export const SEND_FROM = [
    { code: 'US', label: 'United States', currency: 'USD' },
    { code: 'UK', label: 'United Kingdom', currency: 'GBP' },
    { code: 'CA', label: 'Canada', currency: 'CAD' },
    { code: 'AU', label: 'Australia', currency: 'AUD' },
    { code: 'FR', label: 'France', currency: 'EUR' },
]

// Dropdown options + phone rules for "Send to"
export const SEND_TO = [
    {
        code: 'SL',
        label: 'Sierra Leone',
        currency: 'SLE',
        dialCode: '+232',
        prefixes: ['76', '77', '78', '79', '30', '31', '32', '33'],
        operators: ['Orange Money', 'Africell Money'],
    },
    {
        code: 'LR',
        label: 'Liberia',
        currency: 'USD',
        dialCode: '+231',
        // Replace these with your real supported prefixes
        prefixes: ['77', '88', '55', '66'],
        operators: ['Orange Money', 'Lonestar MTN Mobile Money'],
    },
    {
        code: 'GN',
        label: 'Guinea',
        currency: 'GNF',
        dialCode: '+224',
        // Replace these with your real supported prefixes
        prefixes: ['62', '66', '60', '61'],
        operators: ['Orange Money', 'MTN MoMo'],
    },
    {
        code: 'GM',
        label: 'Gambia',
        currency: 'GMD',
        dialCode: '+220',
        prefixes: ['2', '3', '5', '6', '7', '9'],
        operators: ['Africell Gambia', 'QCell', 'Gamcel'],
    },
]

export const getSendToRule = (toCode) => {
    if (!toCode) return null
    return SEND_TO.find((x) => x.code === String(toCode).toUpperCase()) || null
}

export const getSendFromOption = (fromCode) => {
    if (!fromCode) return null
    return SEND_FROM.find((x) => x.code === String(fromCode).toUpperCase()) || null
}

